import { CatalogueEntity } from './catalogue-entity.model';

export abstract class OpeningProperties extends CatalogueEntity {
    thermalConductivity: number;
    confirmed?: boolean;
}
